import React from 'react';

import LoginCreds from '../../components/loginpages/LoginCreds';
import { TSPCategory, TSPConfig } from '../types';

const g2geldConfig: TSPConfig = {
  key: 'g2geld',
  name: 'G2G ELD',
  imageName: 'G2GELD',
  category: TSPCategory.CUSTOM,
  helpText: 'Please input the Company ID from your G2G ELD profile.',
  loginComponent: (props) => (
    <LoginCreds
      onValidityChange={props.onValidityChange}
      fields={[
        {
          label: 'Enter Company ID',
          name: 'authorizationcode',
          type: 'text',
          required: true,
        },
      ]}
    />
  ),
};

export default g2geldConfig;
